<template>
<el-dialog  title="无账单开票" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="wzdkpFlag" width="1320px" center>
  <div>
    <div style="width:90%;margin:0 auto;">
      <el-form :inline="true" :rules="rules"  :model="kaiPiaoFrom" ref="kaiPiaoFrom" class="demo-form-inline " label-width="100px" size="small">
        <div class="kaip">
          <el-form-item label="结算客户:" prop="payer" >
            <el-select  v-model="kaiPiaoFrom.payer" filterable allow-create placeholder="请选择" >
              <el-option v-for="item in kehuList" :label="item.payee" :value="item.payee" :key="item.payee"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票金额:" class="jiage" prop="invoiceAmount">
            <el-input placeholder="" maxlength="10" v-number-input.float="2"
                  v-model.trim="kaiPiaoFrom.invoiceAmount"></el-input>
            <span class="danwei">元</span>
          </el-form-item>
          <el-form-item label="开票时间:" prop="invoiceTime" >
            <el-date-picker
              v-model="kaiPiaoFrom.invoiceTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item label="发票二维码:" v-if="wzdkpFlag" class="is-required">
            <el-radio-group v-model="moban"   >
              <el-radio label="发票二维码（有销售方）">新模板(有销售方)</el-radio>
              <el-radio label="发票二维码">旧模板(无销售方)</el-radio>
            </el-radio-group>
            <el-button type="primary" style="margin-left:416px" @click="addRWMFn">新增</el-button>
        </el-form-item>
        <el-table :data="kaiPiaoFrom.ewmList"  ref="tableRWM"   bordersize="mini"  style="width: 100%" max-height="500px"  center border>
          <el-table-column type="index"  label="序号" width="60"></el-table-column>
          <el-table-column label="发票二维码图片"  min-width="120">
            <template slot="header" >
              <div><span class="red" >*</span>发票二维码图片</div>
            </template>
            <template slot-scope="scope">
              <div>
                <uploadImgs :imgList.sync='kaiPiaoFrom.ewmList[scope.$index].lookimgList'  v-if="wzdkpFlag" :key="scope.row.key"   @change="change($event,scope.$index)">
                  <i class="el-icon-upload"></i>
                </uploadImgs>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="发票号码"  min-width="120">
            <template slot="header" >
              <div><span class="red" >*</span>发票号码</div>
            </template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'ewmList.' +scope.$index+ '.fphm'" :key="scope.$index" :rules="rules.invoiceNo"  class="table_error">
                  <el-input placeholder="" maxlength="30" style="width:250px"
                    v-model.trim="kaiPiaoFrom.ewmList[scope.$index].fphm"></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="发票金额(元)"  min-width="90">
            <template slot="header" >
              <div><span class="red" >*</span>发票金额(元)</div>
            </template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'ewmList.' +scope.$index+ '.fpje'" :key="scope.$index" :rules="rules.fpje"  class="table_error">
                  <el-input placeholder="" maxlength="10" v-number-input.float="2" style="width:150px"
                    v-model.trim="kaiPiaoFrom.ewmList[scope.$index].fpje"></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作"  width="100">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" @click="delewmFn(scope.$index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <span style="padding: 14px 0;display: inline-block;color:#e6a23c;">至少上传1张发票二维码图片，最多上传10张</span>
        <br>
        <el-form-item label="发票附件:" v-if="wzdkpFlag" >
          <uploadFiles style="width:300px;" :fileArr.sync='imgList' :max='10' v-if="wzdkpFlag"></uploadFiles>
        </el-form-item>
        <br>
        <el-form-item label="申请部门:" prop="createSubdepartmentCode" class="width1">
          <el-select  v-model="kaiPiaoFrom.createSubdepartmentCode" filterable placeholder="请选择" @change="bumenChange">
            <el-option v-for="item in bumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请人:" prop="createUserId" class="width1">
          <el-select  v-model="kaiPiaoFrom.createUserId" filterable placeholder="请选择" @change="yonghuChange">
            <el-option v-for="item in yonghuList" :label="item.userName" :value="item.userCode" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请时间:" prop="createTime" >
            <el-date-picker
              v-model="kaiPiaoFrom.createTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
      </el-form>

    </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" @click="saveFn('kaiPiaoFrom')">确 定</el-button>
  </span>
  <el-image-viewer v-if="dialogVisible" :on-close="closeViewer" :url-list="lookimgList" />
</el-dialog>
</template>
<script>
import { findWayPayeeList, ocrModelList, ocrCustomModelByFile, confirmInvoiceApplyNoBills } from '@/api/newTMS'
import { getCurrUserDepartment, getDepartmentUsers } from '@/api/newCrm'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
import uploadImgs from '@/views/newTMS/publicFiles/uploadImgs.vue'
import { toFixed } from '@/utils/util'
export default {
  components: { ElImageViewer, uploadFiles, uploadImgs },
  name: 'wzdkp',
  props: {
    wzdkpFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      kaiPiaoFrom: {},
      rules: {
        payer: [
          { required: true, message: '请选择结算客户', trigger: 'blur' }
        ],
        invoiceAmount: [
          { required: true, message: '请输入开票金额', trigger: 'blur' }
        ],
        arrivalTime: [
          { required: true, message: '请选择开票时间', trigger: 'blur' }
        ],
        rejectionRemark: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' }
        ],
        invoiceNo: [
          { required: true, message: '请输入发票号码', trigger: 'blur' }
        ],
        fpje: [
          { required: true, message: '请输入发票金额', trigger: 'blur' }
        ],
        invoiceTime: [
          { required: true, message: '请选择开票时间', trigger: 'blur' }
        ],
        createSubdepartmentCode: [
          { required: true, message: '请选择申请部门', trigger: 'blur' }
        ],
        createUserId: [
          { required: true, message: '请选择申请人', trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: '请选择申请时间', trigger: 'blur' }
        ]
      },
      moban: '发票二维码（有销售方）',
      imgList: [],
      dialogVisible: false,
      kehuList: [],
      bumenList: [],
      yonghuList: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.$set(this.kaiPiaoFrom, 'invoiceTime', new Date().getTime())
    this.$set(this.kaiPiaoFrom, 'createTime', new Date().getTime())
    this.$set(this.kaiPiaoFrom, 'ewmList', [{ lookimgList: [], key: 0 }])
    findWayPayeeList(this.searchFrom).then(res => { this.kehuList = res })
    getCurrUserDepartment().then(res => { this.bumenList = res })
  },
  methods: {
    // 上传二维码图片
    change (fileList, index) {
      if (fileList.length > 0) {
        ocrModelList({ labelList: ['唐山曹妃甸兴瀚钢铁物流有限公司'], modelName: this.moban }).then(res => {
          let Id = JSON.parse(res)[0].id
          let imgfile = new FormData()
          imgfile.set('params', JSON.stringify({ modelId: Id }))
          imgfile.append('file', fileList[0].raw)
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          ocrCustomModelByFile(imgfile).then(res => {
            loading.close()
            let data = JSON.parse(res)
            console.log(data)
            this.$set(this.kaiPiaoFrom.ewmList[index], 'fphm', data.invoiceNo)
            data.invoiceAmount = data.invoiceAmount.replace(/,/g, '')
            this.$set(this.kaiPiaoFrom.ewmList[index], 'fpje', data.invoiceAmount)
            // if (data.invoiceAmount != this.kaiPiaoFrom.invoiceAmount) {
            //   this.$alert('发票信息与申请流水信息不一致', '系统提示')
            // }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(error => {
          this.$message.error(error.message)
        })
      }
    },
    // 选择部门
    bumenChange (e) {
      let json1 = this.bumenList.filter(item => item.code == e)
      this.$set(this.kaiPiaoFrom, 'createDepartmentName ', json1[0].name)
      getDepartmentUsers({ subOrgCode: e }).then(res => { this.yonghuList = res })
      this.$set(this.kaiPiaoFrom, 'createUserId', null)
      this.$set(this.kaiPiaoFrom, 'createUser ', null)
    },
    // 选择用户
    yonghuChange (e) {
      let json = this.yonghuList.filter(item => item.userCode == e)
      this.$set(this.kaiPiaoFrom, 'createUser', json[0].userName)
      this.$set(this.kaiPiaoFrom, 'createSubdepartmentName', json[0].subOrgName)
      this.$set(this.kaiPiaoFrom, 'createSubdepartmentCode', json[0].subOrgCode)
      this.$set(this.kaiPiaoFrom, 'createSubcompanyName', json[0].subCompanyName)
      this.$set(this.kaiPiaoFrom, 'createSubcompanyCode ', json[0].subCompanyCode)
    },
    // 二维码添加
    addRWMFn () {
      if (this.kaiPiaoFrom.ewmList.length == 10) {
        this.$alert('最多只能添加10条发票二维码', '系统提示')
        return
      }
      this.kaiPiaoFrom.ewmList.push({
        lookimgList: [],
        key: this.kaiPiaoFrom.ewmList[this.kaiPiaoFrom.ewmList.length - 1].key + 1
      })
    },
    // 二维码删除
    delewmFn (index) {
      if (this.kaiPiaoFrom.ewmList.length == 1) {
        this.$alert('已经是最后一条数据了，不能删除', '系统提示')
        return
      }
      console.log(this.kaiPiaoFrom.ewmList)
      this.deleteImage(this.kaiPiaoFrom.ewmList[index].lookimgList[0])
      this.kaiPiaoFrom.ewmList.splice(index, 1)
    },
    deleteImage () {

    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let flag = this.kaiPiaoFrom.ewmList.every(itme => itme.lookimgList.length != 0)
          if (!flag) {
            this.$alert('请上传发票二维码', '系统提示')
            return
          }
          let allje = 0
          this.kaiPiaoFrom.ewmList.forEach(item => {
            allje += Number(item.fpje)
          })
          allje = toFixed(allje, 2)
          if (allje != toFixed(this.kaiPiaoFrom.invoiceAmount, 2)) {
            this.$confirm('发票金额不匹配是否继续开票?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.jiekou()
            }).catch(() => {

            })
          } else {
            this.jiekou()
          }
        } else {
          return false
        }
      })
    },
    jiekou () {
      let imgfile = new FormData()
      let fphmARR = []
      this.kaiPiaoFrom.ewmList.forEach(item => {
        imgfile.append('filesQr ', item.lookimgList[0].raw)
        fphmARR.push(item.fphm)
      })
      this.imgList.forEach(item => {
        imgfile.append('files', item.raw)
      })
      this.$set(this.kaiPiaoFrom, 'invoiceNo', fphmARR.toString())
      this.$set(this.kaiPiaoFrom, 'pendingAmount', this.kaiPiaoFrom.invoiceAmount)
      imgfile.set('params', JSON.stringify(this.kaiPiaoFrom))
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      confirmInvoiceApplyNoBills(imgfile).then(res => {
        this.$parent.searchFn()
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.$emit('update:wzdkpFlag', false)
        loading.close()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },

    closeDialog () {
      this.$emit('update:wzdkpFlag', false)
    }
  }

}
</script>

<style scoped lang='less'>
.box{
  display: flex;
  justify-content: space-between;
}
.left,.right{
  width: 38%;
}
.right{
  width: 60%;
}
/deep/.el-upload-list__item{
  position: relative;
}
/deep/.chenggong::after {
  content: "成功";
  background-color: #67C23A;
  color: #fff;
  height: 18px;
  width: 26px;
  font-size: 10px;
  text-align: center;
  line-height: 18px;
  // border-radius: 50%;
  position: absolute;
  top:0px;
  right:0px
}
/deep/.shibai::after {
  content: "失败";
  background-color: red;
  color: #fff;
  height: 18px;
  width: 26px;
  font-size: 10px;
  text-align: center;
  line-height: 18px;
  // border-radius: 50%;
  position: absolute;
  top:0px;
  right:0px
}
.tubiaoBox{
  display: flex;
  margin-top: 8px;
}
.tubiao{
  display: inline-block;
  margin-right: 2px;
  color: #fff;
  height: 20px;
  width: 20px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
}
.fapiaohao{
  /deep/.el-input__inner{
    padding: 0px 6px;
    width: 200px;
  }
}
</style>
